import Controller from '@ember/controller';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency';
import AccountService from 'cio/services/account';
import AnalyticsService from 'cio/services/analytics';
import ApiErrorsService from 'cio/services/api-errors';
import AuthService from 'cio/services/auth';
import MomentService from 'cio/services/moment';
import BillingService from 'cio/services/billing';
import DS from 'ember-data';
import RouterService from '@ember/routing/router-service';

export default class AuthenticatedAccountCanceledController extends Controller {
  @service account!: AccountService;
  @service analytics!: AnalyticsService;
  @service apiErrors!: ApiErrorsService;
  @service auth!: AuthService;
  @service moment!: MomentService;
  @service billing!: BillingService;
  @service store!: DS.Store;
  @service router!: RouterService;

  logoWithNameImage = new URL('cio/assets/images/logo-with-name.svg', import.meta.url).toString();
  defaultAccountLogoImage = new URL('cio/assets/images/default-account-logo.svg', import.meta.url).toString();

  @computed('billing.billingInfo.trialSuspended', 'account.current.canReactivate')
  get canReactivate() {
    return this.billing.billingInfo?.trialSuspended === true && this.account.current?.canReactivate;
  }

  @action
  logout() {
    return this.auth.logout(true);
  }

  reactivateAsSuspendedTask = task(async () => {
    this.analytics.track('account', 'reactivation_started');

    try {
      await this.account.current.reactivateAsSuspended({});
      await this.store.queryRecord('account', {});
      await this.billing.initialize({ refresh: true, paramPlanSlug: '', code: '' });
      await this.analytics.track('account', 'reactivation_completed');
      // todo: modify this route to match with new billing page
      this.router.transitionTo('settings.subscription', { queryParams: { reactivated: true } });
    } catch (err) {
      this.apiErrors.report(err);
    }
  });
}
